"use strict";
/**
* MIND CONTACT FORM
*
* @since      1.0
* @package    Mindfolio
* @subpackage Mind Contact Form
* @author     Webmajstr <info@webmajstr.cz>
* @copyright  Copyright (c) 2021 Webmajstr
* @license    GPL2+
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var mind_contact_public_1 = __importDefault(require("./inc/mind-contact-public"));
window.addEventListener('load', function () {
    var mcf_forms = document.querySelectorAll('.mcf-form-holder');
    mcf_forms.forEach(function (el_form) {
        var html_el = el_form;
        var MCF_Instance = new mind_contact_public_1["default"](html_el);
        MCF_Instance.init();
    });
});
